import { observable } from 'mobx';
import { ITextEditorStateService } from './text-editor-state-service.interface';

export default class TextEditorStateService implements ITextEditorStateService {
    /**
     * 文本框是否有文字选中
     */
    @observable
    public isEditorTextExpanded = false;
    /**
     * 是否正在选择文字
     */
    @observable
    public isEditorTextSelecting = false;
    @observable
    public isEditorTextMouseDown = false;
    /**
     * 文本框内容变化flag，用来通知文本框输入了文字
     */
    @observable
    public editorContentChangeFlag = 0;
    public isTextPreview = false;
    public isSlateEditing = false;
}
